import React from 'react'
import { MdOutlineAddCircleOutline } from 'react-icons/md'
import { SessionManager } from '../../utils'

export default function ActionPlus(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {permission?.some(val => val.sub_action_name == route_name) &&
                <MdOutlineAddCircleOutline size={16} className='action-button text-primary me-3'
                    onClick={onClick}
                    data-tooltip-id="global-table-tooltip"
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                    data-tooltip-class-name="bg-info tooltip_msg"
                />
            }
        </>
    )
}
